import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ProjectService from "../Services/ProjectService";
import { fetchUserById, updateUserById } from "../Services/usersService";
import { useAuth } from "../Services/AuthContext";
import "../CSS/ProjectForm.css";

const CreateProject = () => {
  const { organizationId } = useParams();
  const navigate = useNavigate();
  const { user, refreshUser } = useAuth();

  const [projectName, setProjectName] = useState("");
  const [localBasePath, setLocalBasePath] = useState("");
  const [serverBasePath, setServerBasePath] = useState("");
  const [stageBasePath, setStageBasePath] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!projectName.trim()) {
      setError("Project name is required");
      return;
    }

    try {
      //  Create project
      const res = await ProjectService.createProject(organizationId, {
        name: projectName.trim(),
        description: description.trim(),
        localBasePath: localBasePath || null,
        serverBasePath: serverBasePath || null,
        stageBasePath: stageBasePath || null,
      });

      const newProjectId = String(res.data.id);

      //  Fetch user (SAME as Edit User)
      const userRes = await fetchUserById(user.userId);
      const userData = userRes?.data?.data ?? userRes?.data ?? userRes;
      const attributes = userData.attributes || {};

      // Merge project IDs
      const updatedProjectIds = Array.from(
        new Set([...(attributes.swaggerProjectIds || []), newProjectId]),
      );

      //  Update user (EXACT Edit User payload)
      await updateUserById(user.userId, {
        username: userData.username,
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        enabled: userData.enabled,
        attributes: {
          swaggerOrganizationIds: (attributes.swaggerOrganizationIds || []).map(
            String,
          ),
          swaggerProjectIdss: updatedProjectIds,
        },
      });

      navigate(`/organization/${organizationId}/project/${newProjectId}`);
    } catch (err) {
      console.error("Update failed:", err);
      setError("Failed to create project");
    }
  };

  return (
    <div className="project-form-page">
      <h2>Create Project</h2>

      <form onSubmit={handleSubmit} className="project-form">
        <input
          placeholder="Project Name"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          required
        />

        <input
          placeholder="Local Base Path"
          value={localBasePath}
          onChange={(e) => setLocalBasePath(e.target.value)}
        />

        <input
          placeholder="Production Base Path"
          value={serverBasePath}
          onChange={(e) => setServerBasePath(e.target.value)}
        />

        <input
          placeholder="Stage Base Path"
          value={stageBasePath}
          onChange={(e) => setStageBasePath(e.target.value)}
        />

        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        {error && <div className="error-message">{error}</div>}

        <div className="form-actions">
          <button type="submit" className="submit-btn">
            Create
          </button>
          <button
            type="button"
            className="cancel-btn"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateProject;
